import * as React from "react";
import PropTypes from "prop-types";

import { precisionMath } from "./sliderUtils";
import Label from "./Label";

function Graduated({ step, min, max, count, value, renderLabel }) {
  const activeIndexs = [];

  let startIndex = 0;
  let endIndex = 0;

  if (Array.isArray(value)) {
    const [start, end] = value;

    startIndex = precisionMath(start / step - min / step);
    endIndex = precisionMath(end / step - min / step);
    activeIndexs.push(
      precisionMath(Math.ceil(((start - min) / (max - min)) * count))
    );
    activeIndexs.push(
      precisionMath(Math.ceil(((end - min) / (max - min)) * count))
    );
  } else {
    endIndex = precisionMath(value / step - min / step);
    activeIndexs.push(
      precisionMath(Math.ceil(((value - min) / (max - min)) * count))
    );
  }

  const graduatedItems = [];

  for (let i = 0; i < count; i += 1) {
    const classes = `${
      i >= startIndex && i <= endIndex ? "oui-slider-pass" : ""
      // eslint-disable-next-line no-bitwise
    } ${~activeIndexs.indexOf(i) ? "oui-slider-active" : ""}`;
    const mark = precisionMath(i * step + min);
    const lastMark = Math.min(max, mark + step);
    const last = i === count - 1;

    graduatedItems.push(
      <li className={classes} key={i}>
        <Label mark={mark} renderLabel={renderLabel} />
        {last ? (
          <Label mark={lastMark} renderLabel={renderLabel} last={last} />
        ) : null}
      </li>
    );
  }

  return (
    <div className="oui-slider-graduator">
      <ul>{graduatedItems}</ul>
    </div>
  );
}

Graduated.propTypes = {
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  count: PropTypes.number,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number)
  ]),
  renderLabel: PropTypes.func
};

Graduated.displayName = "OrionSliderGraduated";

export default Graduated;
